import React from 'react'
import { observer } from 'mobx-react-lite'

import TextField from '@mui/material/TextField'

import {
  ListItemAction,
  useAccountStore,
  useGlobalCopyStore,
  useEvent,
  ANALYTICS_EVENTS,
} from '../../../common'
import { DebtChartData } from '../../../core/utils/DebtUtils'
import { formatPercentage } from '../../../core/utils/NumberFormatting'

interface InterestRateActionProps {
  debt: DebtChartData
}

export const InterestRateAction = observer(({ debt }: InterestRateActionProps) => {
  const { debts: copy } = useGlobalCopyStore()
  const { updateAccount } = useAccountStore()
  const { onEvent } = useEvent()

  const [rate, setRate] = React.useState<number>(debt.interest_rate ?? 0)
  const isInvalid = rate < 0

  const handleSave = async () => {
    await updateAccount({ ...debt.account, interest_rate: rate })
    debt.interest_rate = rate
    onEvent(ANALYTICS_EVENTS.DEBTS_SAVE_RATE_ACTION, { account_guid: debt.guid })
  }

  const handleCancel = () => {
    setTimeout(() => {
      setRate(debt.interest_rate ?? 0)
    }, 250)
  }

  return (
    <ListItemAction
      isSaveDisabled={isInvalid}
      label={`${copy.details_interest_rate} (%)`}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_interest_rate}
      secondaryText={formatPercentage(Number(debt.interest_rate) / 100) as string}
      zeroStateText={!debt.interest_rate ? copy.add_interest_rate : undefined}
    >
      <TextField
        error={isInvalid}
        fullWidth={true}
        onChange={(e) =>
          setRate(!isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0)
        }
        type="number"
        value={rate}
      />
    </ListItemAction>
  )
})
